// extracted by mini-css-extract-plugin
module.exports = {"disablePointerEvents":"disablePointerEvents--117b1"};